const loanTypeList = [
	{
		id: 0,
		title: "Existing Property",
		value: "existing property",
	},
	{
		id: 1,
		title: "Construction",
		value: "construction",
		// disabled: true
	},
	// {
	// 	id: 2,
	// 	title: "Land",
	// 	value: "Land",
	// 	disabled: true
	// },
	// {
	// 	id: 3,
	// 	title: "Land Servicing",
	// 	value: "Land Servicing",
	// 	disabled: true
	// },
	// {
	// 	id: 4,
	// 	title: "Retrofit/Renovation",
	// 	value: "Retrofit/Renovation",
	// 	disabled: true
	// },
];

export const OpportunityQueryKey = "opportunity"

const ExistingFinancingLoanTypeList = [
	{
		id: 0,
		title: "Existing Property",
		value: "existing property",
	},
	{
		id: 1,
		title: "Construction",
		value: "construction",
	},
	{
		id: 2,
		title: "Land",
		value: "land",
	},
	{
		id: 3,
		title: "Land Servicing",
		value: "land servicing",
	},
	{
		id: 4,
		title: "Retrofit/Renovation",
		value: "retrofit/renovation",
	},
];

const financingTypeList = [
	{
		id: 0,
		title: "First",
		value: "first",
	},
	{
		id: 1,
		title: "Second",
		value: "second",
	},
	{
		id: 2,
		title: "Third+",
		value: "third+",
	},
];
const assetTypeList = [
	{
		id: 0,
		title: "Strata",
		value: "Strata",
	},
	{
		id: 1,
		title: "Non Strata",
		value: "Non Strata",
	},
];
const subAssetTypeList = [
	{
		id: 0,
		title: "Strip Mall",
		value: "Strip Mall",
	},
	{
		id: 1,
		title: "Commercial Mall",
		value: "Commercial Mall",
	},
	{
		id: 2,
		title: "Commercial Bay",
		value: "Commercial Bay",
	},
	{
		id: 3,
		title: "Condominium/Apartment",
		value: "Condominium/Apartment",
	},
	{
		id: 4,
		title: "Row/Townhouse",
		value: "Row/Townhouse",
	},
	{
		id: 5,
		title: "Warehouse",
		value: "Warehouse",
	},
	{
		id: 6,
		title: "Hotel",
		value: "Hotel",
	},
	{
		id: 7,
		title: "Student Housing",
		value: "Student Housing",
	},
	{
		id: 8,
		title: "Retirement Facility",
		value: "Retirement Facility",
	},
	{
		id: 9,
		title: "Storage",
		value: "Storage",
	},
	{
		id: 10,
		title: "Service",
		value: "Service",
	},
	{
		id: 11,
		title: "Raw",
		value: "Raw",
	},
	{
		id: 12,
		title: "Other",
		value: "Other",
	},
];

const companyCountryList = [
	{
		id: 0,
		title: "Canada",
		value: "Canada",
	},
	{
		id: 1,
		title: "United States",
		value: "United States",
	},
];

const projectVisibility = [
	{
		id: 0,
		title: "Private",
		value: "private",
	},
	{
		id: 1,
		title: "Public",
		value: "public",
	},
];

export const opportunityData = {
	ExistingFinancingLoanTypeList,
	loanTypeList,
	financingTypeList,
	assetTypeList,
	subAssetTypeList,
	companyCountryList,
	projectVisibility,
};
